"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const debounce_1 = __importDefault(require("lodash/debounce"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const react_slider_1 = __importDefault(require("react-slider"));
function FormikSlider(props) {
    const { name, debounceTime = 0 } = props;
    const { values, setFieldValue } = (0, formik_1.useFormikContext)();
    const debounceOnChange = (0, react_1.useRef)((0, debounce_1.default)((value) => {
        void setFieldValue(name, value);
    }, debounceTime)).current;
    return ((0, jsx_runtime_1.jsx)(react_slider_1.default, { className: "horizontal-slider", thumbClassName: "thumb", trackClassName: "track", defaultValue: (0, get_1.default)(values, name, [0, 100]), onAfterChange: (value) => debounceOnChange(value), renderThumb: (props, state) => ((0, jsx_runtime_1.jsx)("div", { ...props, children: (0, jsx_runtime_1.jsx)("span", { children: state.valueNow }) })), pearling: true, minDistance: 10 }));
}
exports.default = FormikSlider;
